module.exports = __webpack_public_path__ + "static/media/image_shi_bg.cd917113.png";